var Approval = {
    id: 0,
    uid: 0,
    approveArtist: function() {
        this.approveArtistPromise()
            .then((response) => {
                window.location.reload();
            })
            .catch((error) => {
                //console.log(error.response);
            });
    },
    approveArtistPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.id = Approval.id;
            request.uid = Approval.uid;
            window.axios.post('/admin/approvals/artist', request)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    },
    approveDistro: function() {
        this.approveDistroPromise()
            .then((response) => {
                window.location.reload();
            })
            .catch((error) => {
                //console.log(error.response);
            });
    },
    approveDistroPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.id = Approval.id;
            request.uid = Approval.uid;
            window.axios.post('/admin/approvals/distro', request)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    },
    approveAlbum: function() {
        this.approveAlbumPromise()
            .then((response) => {
                window.location.reload();
            })
            .catch((error) => {
                //console.log(error.response);
            });
    },
    approveAlbumPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.id = Approval.id;
            request.uid = Approval.uid;
            window.axios.post('/admin/approvals/album', request)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    }
}

var Pending = {
    id: 0,
    uid: 0,
    pendingArtist: function() {
        this.pendingArtistPromise()
            .then((response) => {
                window.location.reload();
            })
            .catch((error) => {
                //console.log(error.response);
            });
    },
    pendingArtistPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.id = Pending.id;
            request.uid = Pending.uid;
            window.axios.post('/admin/pending/artist', request)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    },
    pendingDistro: function() {
        this.pendingDistroPromise()
            .then((response) => {
                window.location.reload();
            })
            .catch((error) => {
                //console.log(error.response);
            });
    },
    pendingDistroPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.id = Pending.id;
            request.uid = Pending.uid;
            window.axios.post('/admin/pending/distro', request)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    },
    pendingAlbum: function() {
        this.pendingAlbumPromise()
            .then((response) => {
                window.location.reload();
            })
            .catch((error) => {
                //console.log(error.response);
            });
    },
    pendingAlbumPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.id = Pending.id;
            request.uid = Pending.uid;
            window.axios.post('/admin/pending/album', request)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    }
}

var Rejection = {
    id: 0,
    uid: 0,
    name: '',
    type: '',
    message: '',
    show: function() {
        $('#name-label').text(this.name);
        $('body').removeClass('overflow-auto').addClass('overflow-hidden');
        $('#rejection').css({ top: window.pageYOffset }).show();
    },
    hide: function() {
        $('#rejection').css({ top: window.pageYOffset }).hide();
        $('body').removeClass('overflow-hidden').addClass('overflow-auto');
        // reset the modal state
        this.resetState();
    },
    resetState: function() {
        Rejection.name = '';
        Rejection.type = '';
        Rejection.message = '';
        $('#message').val('').keyup();
    },
    rejectArtist: function() {
        this.rejectArtistPromise()
            .then((response) => {
                window.location.reload();
            })
            .catch((error) => {
                //console.log(error.response);
            });
    },
    rejectArtistPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.id = Rejection.id;
            request.uid = Rejection.uid;
            request.message = Rejection.message;
            window.axios.post('/admin/rejections/artist', request)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    },
    rejectDistro: function() {
        this.rejectDistroPromise()
            .then((response) => {
                window.location.reload();
            })
            .catch((error) => {
                //console.log(error.response);
            });
    },
    rejectDistroPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.id = Rejection.id;
            request.uid = Rejection.uid;
            request.message = Rejection.message;
            window.axios.post('/admin/rejections/distro', request)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    },
    rejectAlbum: function() {
        this.rejectAlbumPromise()
            .then((response) => {
                window.location.reload();
            })
            .catch((error) => {
                //console.log(error.response);
            });
    },
    rejectAlbumPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.id = Rejection.id;
            request.uid = Rejection.uid;
            request.message = Rejection.message;
            window.axios.post('/admin/rejections/album', request)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    }
}

$(document).ready(function() {
    // click add artist
    $('.approveArtist').on('click', function() {
        // get inputs
        Approval.id = $(this).data('id');
        Approval.uid = $(this).data('uid');
        Approval.approveArtist();
    });
    // click add distro
    $('.approveDistro').on('click', function() {
        // get inputs
        Approval.id = $(this).data('id');
        Approval.uid = $(this).data('uid');
        Approval.approveDistro();
    });
    // click add album
    $('.approveAlbum').on('click', function() {
        // get inputs
        Approval.id = $(this).data('id');
        Approval.uid = $(this).data('uid');
        Approval.approveAlbum();
    });
    // click pending artist
    $('.pendingArtist').on('click', function() {
        // get inputs
        Pending.id = $(this).data('id');
        Pending.uid = $(this).data('uid');
        Pending.pendingArtist();
    });
    // click pending distro
    $('.pendingDistro').on('click', function() {
        // get inputs
        Pending.id = $(this).data('id');
        Pending.uid = $(this).data('uid');
        Pending.pendingDistro();
    });
    // click pending album
    $('.pendingAlbum').on('click', function() {
        // get inputs
        Pending.id = $(this).data('id');
        Pending.uid = $(this).data('uid');
        Pending.pendingAlbum();
    });
    // click reject artist
    $('.rejectArtist').on('click', function(e) {
        e.preventDefault();
        // get inputs
        Rejection.type = 'Artist';
        Rejection.id = $(this).data('id');
        Rejection.uid = $(this).data('uid');
        Rejection.name = $(this).data('name');
        // render the modal
        Rejection.show();
    });
    // click reject distro
    $('.rejectDistro').on('click', function(e) {
        e.preventDefault();
        // get inputs
        Rejection.type = 'Distro';
        Rejection.id = $(this).data('id');
        Rejection.uid = $(this).data('uid');
        Rejection.name = $(this).data('name');
        // render the modal
        Rejection.show();
    });
    // click reject album
    $('.rejectAlbum').on('click', function(e) {
        e.preventDefault();
        // get inputs
        Rejection.type = 'Album';
        Rejection.id = $(this).data('id');
        Rejection.uid = $(this).data('uid');
        Rejection.name = $(this).data('name');
        // render the modal
        Rejection.show();
    });
    // hide or show the approval content
    $('.expander').on('click', function(e) {
        const expandable = $(this).find(':first').parent().parent().find('.expandable');
        const arrowUp = $(this).find(':first').parent().parent().find('.arrowUp');
        const arrowDown = $(this).find(':first').parent().parent().find('.arrowDown');

        if (!$(expandable).is(':visible')) {
            $(expandable).slideDown('fast');
            $(arrowDown).hide();
            $(arrowUp).show();
        } else {
            $(expandable).slideUp('fast');            
            $(arrowUp).hide();
            $(arrowDown).show();
        }
    });
    // message keyup
    $('#message').keyup(function(e) {
        const message = $(this).val();

        $('#message-count').text(message.length);

        // disable the submit button at zero length
        if (message.length <= 0) {
            $('#reject').attr('disabled','disabled').removeClass('bg-green-800 hover:bg-green-900').addClass('bg-gray-700');
        } else {
            $('#reject').removeAttr('disabled').removeClass('bg-gray-700').addClass('bg-green-800 hover:bg-green-900');
        }
    });
    // close the rejection modal
    $('#closeRejection, #cancel').on('click', function(e) {
        Rejection.hide();
    });
    // confirm the rejection
    $('#reject').on('click', function(e) {
        const method = 'reject' + Rejection.type;
        Rejection.message = $('#message').val();
        Rejection[method]();
    });
});